import { graphql } from 'src/graphql';

export const CreateVideoCallBooking = graphql(`
  mutation createVideoCallBooking($input: CreateVideoCallBookingInput!) {
    createVideoCallBooking(input: $input) {
      _id
      name
      type
      status
      config {
        builder
        is_self_scheduling_enabled
      }
    }
  }
`);
